var _circle, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path7, _path8, _path9, _path10, _path11, _rect, _rect2, _circle2, _path12, _polygon, _path13, _path14, _ellipse5, _circle3, _polygon2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _circle4, _rect16, _rect17, _ellipse6, _ellipse7, _circle5, _circle6, _path15, _ellipse8, _ellipse9, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServerError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 1119.60911,
    height: 699,
    viewBox: "0 0 1119.60911 699",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "server down") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 292.60911,
    cy: 213,
    r: 213,
    fill: "#f2f2f2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.39089,151.64237c0,77.49789,48.6181,140.20819,108.70073,140.20819",
    transform: "translate(-31.39089 -100.5)",
    fill: "#2f2e41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140.09162,291.85056c0-78.36865,54.255-141.78356,121.30372-141.78356",
    transform: "translate(-31.39089 -100.5)",
    fill: "#4f31c5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.77521,158.66768c0,73.61476,31.00285,133.18288,69.31641,133.18288",
    transform: "translate(-31.39089 -100.5)",
    fill: "#4f31c5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M140.09162,291.85056c0-100.13772,62.7103-181.16788,140.20819-181.16788",
    transform: "translate(-31.39089 -100.5)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.22379,292.83905s15.41555-.47479,20.06141-3.783,23.713-7.2585,24.86553-1.95278,23.16671,26.38821,5.76263,26.5286-40.43935-2.711-45.07627-5.53549S117.22379,292.83905,117.22379,292.83905Z",
    transform: "translate(-31.39089 -100.5)",
    fill: "#a8a8a8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M168.224,311.78489c-17.40408.14042-40.43933-2.71094-45.07626-5.53548-3.53126-2.151-4.93843-9.86945-5.40926-13.43043-.32607.014-.51463.02-.51463.02s.97638,12.43276,5.61331,15.2573,27.67217,5.67589,45.07626,5.53547c5.02386-.04052,6.7592-1.82793,6.66391-4.47526C173.87935,310.756,171.96329,311.75474,168.224,311.78489Z",
    transform: "translate(-31.39089 -100.5)",
    opacity: 0.2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 198.60911,
    cy: 424.5,
    rx: 187,
    ry: 25.43993,
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 198.60911,
    cy: 424.5,
    rx: 157,
    ry: 21.35866,
    opacity: 0.1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 836.60911,
    cy: 660.5,
    rx: 283,
    ry: 38.5,
    fill: "#3f3d56"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 310.60911,
    cy: 645.5,
    rx: 170,
    ry: 23.12721,
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M494,726.5c90,23,263-30,282-90",
    transform: "translate(-31.39089 -100.5)",
    fill: "none",
    stroke: "#2f2e41",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M341,359.5s130-36,138,80-107,149-17,172",
    transform: "translate(-31.39089 -100.5)",
    fill: "none",
    stroke: "#2f2e41",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M215.40233,637.78332s39.0723-10.82,41.47675,24.04449-32.15951,44.78287-5.10946,51.69566",
    transform: "translate(-31.39089 -100.5)",
    fill: "none",
    stroke: "#2f2e41",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M810.09554,663.73988,802.218,714.03505s-38.78182,20.60284-11.51335,21.20881,155.73324,0,155.73324,0,24.84461,0-14.54318-21.81478l-7.87756-52.719Z",
    transform: "translate(-31.39089 -100.5)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M785.21906,734.69812c6.193-5.51039,16.9989-11.252,16.9989-11.252l7.87756-50.2952,113.9216.10717,7.87756,49.582c9.185,5.08711,14.8749,8.987,18.20362,11.97818,5.05882-1.15422,10.58716-5.44353-18.20362-21.38921l-7.87756-52.719-113.9216,3.02983L802.218,714.03506S769.62985,731.34968,785.21906,734.69812Z",
    transform: "translate(-31.39089 -100.5)",
    opacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 578.43291,
    y: 212.68859,
    width: 513.25314,
    height: 357.51989,
    rx: 18.04568,
    fill: "#2f2e41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 595.70294,
    y: 231.77652,
    width: 478.71308,
    height: 267.83694,
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 835.05948,
    cy: 223.29299,
    r: 3.02983,
    fill: "#f2f2f2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.07694,621.32226V652.6628a18.04341,18.04341,0,0,1-18.04568,18.04568H627.86949A18.04341,18.04341,0,0,1,609.8238,652.6628V621.32226Z",
    transform: "translate(-31.39089 -100.5)",
    fill: "#2f2e41"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "968.978 667.466 968.978 673.526 642.968 673.526 642.968 668.678 643.417 667.466 651.452 645.651 962.312 645.651 968.978 667.466",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1125.828,762.03359c-.59383,2.539-2.83591,5.21743-7.90178,7.75032-18.179,9.08949-55.1429-2.42386-55.1429-2.42386s-28.4804-4.84773-28.4804-17.573a22.72457,22.72457,0,0,1,2.49658-1.48459c7.64294-4.04351,32.98449-14.02122,77.9177.42248a18.73921,18.73921,0,0,1,8.54106,5.59715C1125.07908,756.45353,1126.50669,759.15715,1125.828,762.03359Z",
    transform: "translate(-31.39089 -100.5)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1125.828,762.03359c-22.251,8.526-42.0843,9.1622-62.43871-4.975-10.26507-7.12617-19.59089-8.88955-26.58979-8.75618,7.64294-4.04351,32.98449-14.02122,77.9177.42248a18.73921,18.73921,0,0,1,8.54106,5.59715C1125.07908,756.45353,1126.50669,759.15715,1125.828,762.03359Z",
    transform: "translate(-31.39089 -100.5)",
    opacity: 0.1
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1066.53846,
    cy: 654.13477,
    rx: 7.87756,
    ry: 2.42386,
    fill: "#f2f2f2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 835.05948,
    cy: 545.66686,
    r: 11.51335,
    fill: "#f2f2f2"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "968.978 667.466 968.978 673.526 642.968 673.526 642.968 668.678 643.417 667.466 968.978 667.466",
    opacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 108.60911,
    y: 159,
    width: 208,
    height: 242,
    fill: "#2f2e41"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 87.60911,
    y: 135,
    width: 250,
    height: 86,
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 87.60911,
    y: 237,
    width: 250,
    height: 86,
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 87.60911,
    y: 339,
    width: 250,
    height: 86,
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 271.60911,
    y: 150,
    width: 16,
    height: 16,
    fill: "#4f31c5",
    opacity: 0.4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 294.60911,
    y: 150,
    width: 16,
    height: 16,
    fill: "#4f31c5",
    opacity: 0.8
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 317.60911,
    y: 150,
    width: 16,
    height: 16,
    fill: "#4f31c5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 271.60911,
    y: 251,
    width: 16,
    height: 16,
    fill: "#4f31c5",
    opacity: 0.4
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 294.60911,
    y: 251,
    width: 16,
    height: 16,
    fill: "#4f31c5",
    opacity: 0.8
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 317.60911,
    y: 251,
    width: 16,
    height: 16,
    fill: "#4f31c5"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 271.60911,
    y: 352,
    width: 16,
    height: 16,
    fill: "#4f31c5",
    opacity: 0.4
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 294.60911,
    y: 352,
    width: 16,
    height: 16,
    fill: "#4f31c5",
    opacity: 0.8
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 317.60911,
    y: 352,
    width: 16,
    height: 16,
    fill: "#4f31c5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.60911,
    cy: 538,
    r: 79,
    fill: "#2f2e41"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 280.60911,
    y: 600,
    width: 24,
    height: 43,
    fill: "#2f2e41"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 328.60911,
    y: 600,
    width: 24,
    height: 43,
    fill: "#2f2e41"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300.60911,
    cy: 643.5,
    rx: 20,
    ry: 7.5,
    fill: "#2f2e41"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 348.60911,
    cy: 642.5,
    rx: 20,
    ry: 7.5,
    fill: "#2f2e41"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 318.60911,
    cy: 518,
    r: 27,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 318.60911,
    cy: 518,
    r: 9,
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M271.36733,565.03228c-6.37889-28.56758,14.01185-57.43392,45.544-64.47477s62.2651,10.41,68.644,38.9776-14.51861,39.10379-46.05075,46.14464S277.74622,593.59986,271.36733,565.03228Z",
    transform: "translate(-31.39089 -100.5)",
    fill: "#4f31c5"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 417.21511,
    cy: 611.34365,
    rx: 39.5,
    ry: 12.40027,
    transform: "translate(-238.28665 112.98044) rotate(-23.17116)",
    fill: "#2f2e41"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 269.21511,
    cy: 664.34365,
    rx: 39.5,
    ry: 12.40027,
    transform: "translate(-271.07969 59.02084) rotate(-23.17116)",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M394,661.5c0,7.732-19.90861,23-42,23s-43-14.268-43-22,20.90861-6,43-6S394,653.768,394,661.5Z",
    transform: "translate(-31.39089 -100.5)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerError);
export default __webpack_public_path__ + "static/media/server-error.dbc3609c79a7d096d2ca62291ed5ac79.svg";
export { ForwardRef as ReactComponent };